import { render, staticRenderFns } from "./prod-vid.vue?vue&type=template&id=fd66eeaa&scoped=true&"
import script from "./prod-vid.vue?vue&type=script&lang=js&"
export * from "./prod-vid.vue?vue&type=script&lang=js&"
import style0 from "./prod-vid.vue?vue&type=style&index=0&id=fd66eeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd66eeaa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
